import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  #darkMode: boolean = false;
  #isDark: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.#darkMode);

  isDarkMode(): Observable<boolean> {
    return this.#isDark.asObservable();
  }

  switchDarkMode(): void {
    this.#isDark.next(!this.#isDark.value);

    if (this.#isDark.value) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
  }
}
